import { mountHTTPInstance } from '@ghq-abi/auth-client-lib/client';

import { isProduction } from '../utils/environments';

import { attachLocalDevTokenInterceptor } from './attachLocalDevTokenInterceptor';

export const api = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_BOILERPLATE_API_URL
});

export const nextApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_BOILERPLATE_APP_URL
});

export const peoplePlatformApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_PEOPLE_PLATFORM_API_URL
});

export const eibHubApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_EIB_HUB_API_URL
});

export const peoplePlatformPhotoApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_PHOTO_API_URL
});

attachLocalDevTokenInterceptor(api);
attachLocalDevTokenInterceptor(nextApi);
attachLocalDevTokenInterceptor(peoplePlatformApi);
attachLocalDevTokenInterceptor(peoplePlatformPhotoApi);

// Redirect to the EIB maintenance page on any backend unavailability error (5xx or no response).
// Runs on the client side only; skips redirect when already on the maintenance page.
if (
  typeof window !== 'undefined' &&
  process.env.NODE_ENV !== 'test' &&
  isProduction()
) {
  eibHubApi.interceptors.response.use(
    response => response,
    error => {
      const isEibRoute = window.location.pathname.startsWith('/eib');
      const isMaintenancePage = window.location.pathname === '/eib/maintenance';
      const isServerOrNetworkError =
        !error.response || (error.response?.status ?? 0) >= 500;

      if (isEibRoute && !isMaintenancePage && isServerOrNetworkError) {
        window.location.replace('/eib/maintenance');
      }

      return Promise.reject(error);
    }
  );
}
